import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AssetSearchComponent } from '@zero/shared/ui-web-components';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import { Asset, InstrumentType } from '@zero/shared/util-models';

@Component({
  selector: 'trade-create-asset',
  templateUrl: './trade-create-asset.component.html',
  styleUrls: ['./trade-create-asset.component.scss'],
  imports: [AssetSearchComponent, TranslocoPipe, IconComponent],
})
export class TradeCreateAssetComponent {
  @Input() public isinsInPortfolio: { isin: string }[] = [];
  @Input() public asset?: Asset;
  @Input() public isDisabled = false;
  @Input() public assetNotFound = false;

  @Output() public selectAsset = new EventEmitter<Asset>();
  @Output() public resetAsset = new EventEmitter<void>();

  public readonly InstrumentType = InstrumentType;
}
